import { NormalizedTicketTypeVariety } from '../../types/ticketPriceInformation';
import { consumer } from '@tock/coretypes';

/**
 * The natural name of an offering is the name used in regular language.
 * This can be placed into text on the dashboard or consumer sites.
 */

export type OfferingNaturalName = 'experience' | 'event' | 'special table';
const varietyToOfferingNaturalNameMap: {
  [K in NormalizedTicketTypeVariety | consumer.Offering.Type]: OfferingNaturalName;
} = {
  DEPOSIT: 'experience',
  FULL: 'experience',
  PRIX_FIXE: 'experience',
  RESERVATION: 'experience',
  DEPRECATED_EVENT: 'event',
  GA_EVENT: 'event',
  SEATED_EVENT: 'event',
  DEPRECATED_SPECIAL_TABLE: 'special table',
  ORDER_DELIVERY: 'experience',
  ORDER_PICKUP: 'experience',
  TABLESIDE: 'experience',
  PAYMENT_CARD_HOLD: 'experience',
};

/**
 * Returns the natural name of a variety
 * e.g. RESERVATION -> experience, SPECIAL_TABLE -> special table, DEPOSIT -> experience
 */
export function offeringNaturalName(
  variety: NormalizedTicketTypeVariety | consumer.Offering.Type
): OfferingNaturalName {
  return varietyToOfferingNaturalNameMap[variety];
}
